"use client"

import { useEffect } from "react"

export default function PopupBackground(props: {
  id: string
  visibility: boolean
  children?: React.ReactNode
}) {
  const onScroll = () => {
    if (document.getElementById(props.id)?.checkVisibility()) {
      window.scrollTo(0, 0)
    }
  }

  useEffect(() => {
    window.scrollTo(0, 0)
    window.addEventListener("scroll", onScroll, { passive: true })

    return () => {
      window.removeEventListener("scroll", onScroll)
    }
  }, [])
  return (
    <div
      id={props.id}
      className={`${
        props.visibility ? "visible" : "hidden"
      } absolute top-0 left-0 z-10 flex items-center justify-center w-full h-screen overflow-y-hidden bg-gray-500 bg-opacity-50`}
    >
      {props.children}
    </div>
  )
}
